module.exports = "<form @submit.prevent=submit> <label class=\"inp-text label-prop\" :class=special> <input-subtle :model.sync=prop placeholder=property... @blur=submit @keydown.enter=submit style=opacity:.7></input-subtle> <input class=inp-big-focus v-model=value :placeholder=\"prop&&'value...'\" @blur=submit @keyup.enter=submit> </label> </form>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PropAdd.vue
 ** module id = 141
 ** module chunks = 0
 **/